// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_bb-3";
export var contentContainer = "_bb-0";
export var editorContainer = "_bb-1";
export var quillInputForm = "_bb-2";
export var zoneDivider = "_bb-4";